/**
 * Delivery Information Handler
 * Manages delivery day calculations and display
 */

class DeliveryInfo {
  constructor() {
    this.init();
  }

  init() {
    // Initialize delivery info on page load
    this.updateDeliveryInfo();
    
    // Update delivery info when cart changes
    document.addEventListener('cart:updated', () => {
      this.updateDeliveryInfo();
    });
  }

  updateDeliveryInfo() {
    const deliveryElements = document.querySelectorAll('.delivery-info');
    
    deliveryElements.forEach(element => {
      // Add any dynamic updates here if needed
      // For now, the delivery info is static based on theme settings
      if (element) {
        element.style.display = 'flex';
      }
    });
  }

  calculateDeliveryDates(minDays = 3, maxDays = 7) {
    const today = new Date();
    const minDate = new Date(today);
    const maxDate = new Date(today);
    
    minDate.setDate(today.getDate() + minDays);
    maxDate.setDate(today.getDate() + maxDays);
    
    return {
      minDate: minDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }),
      maxDate: maxDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
    };
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new DeliveryInfo();
});